import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import Fab from "@material-ui/core/Fab";


export default function Server  (){
    
  
    return (
        <>
        <div className="navbar-dark" style={{color:"white",backgroundColor:"#343A40"}}>
        
       
        <br/>
        <center>
        <input
            type="text"
            disabled
            value="How it works"
            style={{
              height: "57px",
              width: "200px",
              borderRadius: "5px",
              padding: "20px",
              color:"white",
              
              background: "#212121",
              border: "2px",
            }}
          />
            <Fab
            color="primary"
            
            style={{
              background: "#b71c1c",
              borderRadius: "7px",
              
            }}
            
          >
            <SettingsIcon/>
          </Fab>
          </center>
          <br/>
        </div>
        <div style={{color:"gray",backgroundColor:"#212121",height:"150%"}}>
          <br/>
          
         <ul>
         <li><i>The WebApp works as a clone to movie streaming sites such as Netflix and Amazon Prime.</i></li>
           <hr/>
           
           <li><i>The WebApp uses OMDb and TMDb Api's to fetch information about webseries and movies.</i></li>
           <hr/>
          
           <li><i>It fetches torrent/telegram groups and websites for the selected  movies and webseries.</i></li>
           <hr/>
          
           <li><i>Once fectched it converts the link to a "Magnet URI " and streams it directly.</i></li>
           <hr/>
           
           <li><i>Some movies or webseries may not be streamed due to lack of seeders and leechers or due to unavaiablity</i></li>
           <hr/>
          
         </ul>

        </div>



      
        </>
    )

}